<template>
  <page-header
    :title-ch="titleCh"
    :title-en="''"
  >
    <div class="light first mobile_hide" />
    <div class="light second" />
    <div class="light third" />
    <div class="light fourth mobile_hide" />
  </page-header>
</template>
<script>
import PageHeader from '~components/pages/Header'
export default {
  name: 'CareerCounsellingHeader',
  components: {
    PageHeader
  },
  props: {
    titleCh: {
      type: String,
      default: ''
    },
    titleEn: {
      type: String,
      default: ''
    }
  }
}
</script>
